// `package` , the catering item. Priced per head, with optional named tiers and
// production hints (min headcount, lead time, deposit %). "Choose N from M"
// selections reuse menu_item_option_groups, so they are NOT in this profile.
// doc 38 Part 1.

import { z } from 'zod';

import type { ItemKindDefinition } from './registry-types';
import type { PackageProfile } from './types';

export const PackageTierSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  price_per_person: z.number().min(0),
});

export const PackageProfileSchema = z.object({
  min_headcount: z.number().int().min(0).optional(),
  lead_time_days: z.number().int().min(0).optional(),
  deposit_pct: z.number().min(0).max(100).optional(),
  tiers: z.array(PackageTierSchema).default([]),
  serves_note: z.string().max(500).optional(),
});

export const packageKind: ItemKindDefinition<PackageProfile> = {
  id: 'package',
  label: 'Package',
  noun: 'package',
  description: 'A per-head catering package with optional tiers and a deposit.',
  defaultPricingMode: 'per_person',
  allowedPricingModes: ['per_person', 'flat'],
  schema: PackageProfileSchema as unknown as z.ZodType<PackageProfile>,
  defaultProfile: () => ({ tiers: [] }),
};
